.dataTransferBox {
  height: 360px;
}
